import _ from 'lodash';

export function inpageNav() {

  const delay = 10;

  let threshold = 50;
  let $nav = $('.C21');
  let $navList = $nav.find('.C21-nav-list');
  let $navItems = $nav.find('.C21-nav-list a');
  let $mobileControls = $nav.find('.C21-mobile-controls');
  let $up = $mobileControls.find('.js-c21-mobile-controls-up');
  let $down = $mobileControls.find('.js-c21-mobile-controls-down');
  let $sections = [];
  let initDistance = false;
  let mobileControlsShowing = false;

  let checkInpageNavDistanceFromTop = function () {

    let scrollTop = $(window).scrollTop(),
      elementOffset = $nav.offset().top,
      distance = (elementOffset - scrollTop);

    if (initDistance === false) {
      initDistance = elementOffset;
    }

    if (scrollTop < initDistance) {
      $nav.removeClass('fixed');
      $nav.next().css('margin-top', 0);
    } else {
      $nav.addClass('fixed');
      $nav.next().css('margin-top', $nav.outerHeight(true));
    }

    checkMobileControlsVisibility();
    checkSectionsLocation();

  };

  let getSections = function() {
    $navItems.each(function(index, element) {
      $sections.push($(element.hash));
    });
  };

  let getDistance = function($el) {
    return $el.offset().top - $(window).scrollTop();
  };

  let checkMobileControlsVisibility = function() {
    if ($mobileControls.is(':visible')) {
      mobileControlsShowing = true;
      threshold = 80;
    } else {
      mobileControlsShowing = false;
      threshold = 50;
    }
  };

  let checkSectionsLocation = function() {
    var $currentSection;
    jQuery.each($sections, function(index, $el) {
      let distance = getDistance($el) - threshold;
      if (distance < 0) {
        if ($currentSection) {
          let currentSectionDistance = getDistance($currentSection);
          if (distance > currentSectionDistance) {
            $currentSection = $el;
          }
        } else {
          $currentSection = $el;
        }
      }
    });
    if ($currentSection) {
      setActiveNavItem($currentSection.attr('id'));
    } else {
      setActiveNavItem(false)
    }
  };

  let setActiveNavItem = function(id) {
    if (id === false ) {
      $navItems.removeClass('active');
      return;
    }
    $navItems.removeClass('active');
    $navItems.filter('a[href="#'+id+'"]').addClass('active');

    if (mobileControlsShowing) {
      let activeIndex = $navItems.filter('.active').parent('li').index();
      let newTop = activeIndex * $nav.outerHeight() * -1;
      $navList.css('top', newTop);
    }
  };

  getSections();
  checkInpageNavDistanceFromTop();

  $(window).on('scroll', _.debounce(checkInpageNavDistanceFromTop, delay));
  $(window).on('resize', _.debounce(checkInpageNavDistanceFromTop, delay));
  $(window).on('hashchange', function(e) {
    let scrollTop = $(window).scrollTop();
    $(window).scrollTop(scrollTop - (threshold-10));
  });

  $up.on('click', function(e){
    e.preventDefault();
    let $prev = $navItems.filter('.active').parent('li').prev().find('a');
    if($prev.length) {
      window.location = $prev[0].href;
    } else {
      window.location = $navItems[0].href;
    }
  });

  $down.on('click', function(e) {
    e.preventDefault();
    let $next = $navItems.filter('.active').parent('li').next().find('a');
    if($next.length) {
      window.location = $next[0].href;
    } else {
      window.location = $navItems[0].href;
    }
  });

}


// WEBPACK FOOTER //
// ./resources/js/utils/inpageNav.js